document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.swiper').forEach((swiperElement, index) => {
    const loop = swiperElement.getAttribute('data-loop') === 'true';
    const autoplay = parseInt(swiperElement.getAttribute('data-autoplay')) || 0;
    const speed = parseInt(swiperElement.getAttribute('data-speed')) || 500;
    const slidesPerViewSp = parseFloat(swiperElement.getAttribute('data-slides-per-view-sp')) || 1;
    const slidesPerViewPc = parseFloat(swiperElement.getAttribute('data-slides-per-view-pc')) || 1;
    const paddingSp = parseInt(swiperElement.getAttribute('data-padding-sp')) || 8;
    const paddingPc = parseInt(swiperElement.getAttribute('data-padding-pc')) || 8;
    
    new Swiper(swiperElement, {
      loop: loop,
      autoplay: autoplay ? { delay: autoplay, disableOnInteraction: false } : false,
      speed: speed,
      slidesPerView: slidesPerViewSp,
      centeredSlides: true,
      spaceBetween: paddingSp,
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: swiperElement.querySelector('.swiper-button-next'),
        prevEl: swiperElement.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: slidesPerViewPc,
          spaceBetween: paddingPc
        }
      }
    });
  });
});